export class PaymentDetails
{
    RequestDate: string;

    ServiceName: string;

    Quantity: string;

    Amount: number;

    Price: number;

    ServiceCode: string;

    ServiceChecked: boolean;

    AmountString: string;

    priceString: string;	

	AdjustedAmount : number;

	AdjustedAmountString : string;

	Co_payAmount : number;

	SponsorCode : string;

    SponsorName: string;	

    ReceiptNo: string;
    SpocatCode: string;
    ReqDetailNo: string;
    LocationCode: string;
    DoctorCode: string;
    RequestFrom: string;
    UserIdm: string;
    PharmacyReceiptNo: string;
    InvoiceNo: string;
    Pintercompanycode: string;
    AdjustFromPrevCopay: string;
    FollowUP_OPNo: string;
    PolicyNo: string;
    MemberNo: string;
    ActualPatientPart: number;
    SelfPayAmount: number;
    SpecialDiscount: string;
    BillwithMother: string;
    DepartmentName: string;

    CustomerCode: string;
    InvCustomerCode: string;

    IPNo: string;
    OPNo: string;
    PackageRegnNo: string;

    StandardDiscount: string;

    StandardCharge: number;
    GroupCode: string;
    DEDUCTIBLE_AMT: number;
    ORIGINAL_COPAY: number;
    ADDITIONALDISCOUNT: string;
    VISIT_NO: string;
    DrugCode: string;
    ItemCode: string;
    PatientSettlesBill: string;
    DefaultCopay: string;
    BillingTOB: string;
    ExclusionRemark: string;
    RiskBillingFlag: string;
    patientid: string;
    TotalAmount: string;
    appNumber: string;
    RedirectResult: string;
    CaptureData: string;
    DisplayDate: string;
    IsProceedPayNow: string;
    IsPortalKiosk: string;
}





// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/model/booking/PaymentDetailsModel.ts